import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-2.25rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-73" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-74" data-mp="23wmhx6pahhi6">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-coral sm:text-xs" data-id="element-75" data-mp="30lu50j5k3yo7">
          KOMPLETNY PROGRAM TRENINGU SIATKÓWKI
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.05rem] font-black uppercase leading-[1.02] tracking-tight text-brand-navy sm:text-[3.2rem] md:text-[3.6rem]" data-id="element-76" data-mp="2mrt8zx5zoprj">
          Prowadź cały rok treningów <span className="italic text-brand-coral" data-id="element-77" data-mp="3fha10tpp64n8">siatkówki</span> w zaledwie 5 minut
          przygotowań
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-78" data-mp="3kb4ehfeplndv">
          Gotowi na Siatkówkę to kompletny program gotowy do użycia — 6 tomów pełnych techniki, taktyki i gotowych sesji
          treningowych, od podstaw do wysokiego poziomu, dla dzieci od 6 do 17+ lat.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/4nBffcKxXfEkkSJ8Facd4P/ChatGPT_Image_18_ago_2026,_10_34_32-Photoroom.png" alt="Pakiet Gotowi na Siatkówkę: sześć tomów treningowych, materiały cyfrowe i pięć bonusów" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-79" data-mp="2ke3g2440ubjr" />
        <div className="flex w-full flex-col items-center" data-id="element-80" data-mp="381tlhtr8giyz">
          <CTAButton className="min-w-[214px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[240px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-81" data-mp="336e9z8gp6z5q">
            CHCĘ PAKIET GOTOWI NA SIATKÓWKĘ
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-82" data-mp="18sdcaqwvwi78">
            ✓ Natychmiastowy dostęp <span className="px-1 text-brand-coral" data-id="element-83" data-mp="3dsefdbw7acvy">·</span> ✓ Dożywotni dostęp
          </p>
        </div>
      </motion.div>
    </section>;
}